
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
    EventFlowLocation,
    ExtraFunctionFormData,
} from '@/model/event-flow/EventFlow';
import EventFlowLocationName from '@/components/event-flow/EventFlowLocationName.vue';

@Component({
    components: {
        EventFlowLocationName,
    },
})
export default class EventFlowLocationHeader extends Vue {
    @Prop() readonly eventFlowLocations!: EventFlowLocation[];
    @Prop() readonly extraFunctionFormData!: ExtraFunctionFormData;
}
